function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesLightbulbFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 14h4v2H2v-2zM6.52 5l2.83 2.83-1.41 1.41-2.83-2.83L6.52 5zM17 1v4h-2V1h2zM26 14h4v2h-4v-2zM23 8l2.83-2.83 1.41 1.41-2.83 2.83L23 8zM20.49 26.01h-8.97v-3.66c-.01-.21-.38-.93-.79-1.29A8.057 8.057 0 018 15.02C8 10.6 11.59 7 16 7s8 3.6 8 8.02c0 2.31-1 4.51-2.73 6.04-.41.36-.77 1.08-.78 1.29v3.66zm-6.98-2h4.97v-1.66c0-.93.76-2.17 1.46-2.79a6.04 6.04 0 002.05-4.53c0-3.32-2.69-6.02-6-6.02s-6 2.7-6 6.02c0 1.74.75 3.39 2.05 4.53.7.62 1.47 1.86 1.47 2.79v1.66zM12 28h8v2h-8v-2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesLightbulbFilled;